var _window$GLOBAL_INFO;
export const isDev = process.env.NODE_ENV === 'development';
// 是否外网版本
export const isExternalDeploy = !!((_window$GLOBAL_INFO = window.GLOBAL_INFO) !== null && _window$GLOBAL_INFO !== void 0 && _window$GLOBAL_INFO.externalDeploy);
// 是否需要显示已废弃功能
export const isDeprecated = location.search.split('&').some(keyValue => /\??deprecated=1/.test(keyValue));
//# sourceMappingURL=envs.js.map
